<template>
  <div class="score-bar-wrap">
    <div class="score-bar-track">
      <div class="score-bar-fill" :style="{ width: `${clampedScore}%`, background: fillColor }" />
    </div>
    <span class="score-text" :style="{ color: fillColor }">{{ score.toFixed(1) }}%</span>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  score: { type: Number, default: 0 }, // 0–100
})

const clampedScore = computed(() => Math.min(100, Math.max(0, props.score)))

const fillColor = computed(() => {
  if (props.score >= 90) return "#4ade80"
  if (props.score >= 80) return "#f5a623"
  return "#f87171"
})
</script>

<style scoped>
.score-bar-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.score-bar-track {
  width: 80px;
  height: 5px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 3px;
  overflow: hidden;
}

.score-bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.6s ease;
}

.score-text {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  min-width: 40px;
}
</style>
